<template>
  <!--  面对面邀请二维码-->
  <div class="invitation">
    <div class="qr-code-div">
      <div class="bg-up">
        <img src="../../assets/images/coins/share_bg_top.png" style="">
      </div>

      <div class="content">
        <div class="qr-code-content" style="">
          <img class="qr-code" src="../../assets/images/coins/logo@2x.png">
        </div>
        <div class="btn-content">
          <div class="btn-div btn-default">
            <van-button round color="#FFB111FF" @click="clickDownload">下载客户端</van-button>
          </div>

          <div class="btn-div">
            <van-button round plain color="#FFB111FF" @click="clickDownload">已下载APP 立即打开
            </van-button>
          </div>
        </div>
      </div>
      <div class="bg-down">
        <img src="../../assets/images/coins/share_bg_down.png" style="">
      </div>
    </div>


    <van-overlay :show="overlayShow" @click="overlayShow = false" :z-index="999">
      <div>
        <img class="share-img" src="../../assets/images/coins/share.png">
      </div>
    </van-overlay>

  </div>
</template>

<script>
export default {
  name: 'invitation',
  data () {
    return {
      overlayShow: false,
      isApp: true,
      url: undefined,
      title: undefined
    }
  },

  mounted () {

    this.ud = this.$route.query.ud  // userId_companyId
    this.url = this.$route.query.l  // 地址
    this.title = this.$route.query.n  // 页面title
    this.id = this.$route.query.d  // 数据id
    this.type = this.$route.query.t  // 数据类型：1-项目；2-找活
    this.projectType = this.$route.query.pt   // 项目类型：1-标准；2-简易

    this.clickDownload()
  },
  methods: {

    clickDownload () {
      let fullPath, module
      if (this.url) {
        module = this.title
        fullPath = this.url + '?d='
      } else {
        if (this.type == 1) {
          module = '找活'
          fullPath = '/projectInfo?id=' + this.id + '&projectType=' + this.projectType + '&ud=' + this.ud
        } else if (this.type == 2) {
          module = '招工'
          fullPath = '/getWorkAdvertising?ud=' + this.ud
        }
      }

      // 通过ua标识判断
      var userAgent = navigator.userAgent.toLowerCase()//获取UA信息

      // 不在app内
      if (userAgent.indexOf('yaogong') == -1) {//判断ua中是否含有和app端约定好的标识yaogong
        this.isApp = false
        if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
          // 在微信中展示遮罩提示浏览器打开
          this.overlayShow = true
        } else {
          this.$utils.initApp(fullPath, module)
        }
      }
    }

  }
}
</script>

<style scoped lang="scss">

.invitation {
  min-height: 100vh;
  background-color: #FFFFFFFF;

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-button--default {
    border-color: #feb114;
    color: #feb114 !important;
  }
}

.btn-default {
  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-button--default {
    border-color: #feb114;
    color: white !important;
    background-color: #feb114 !important;
  }
}

.content {
  position: relative;
  z-index: 999;
  margin: auto;
  margin-top: -200px;
  width: 270px;
  padding: 20px;
  background-color: #FFFFFF;
  border-radius: 10px;
}

.btn-content {
  padding-top: 20px;

  .btn-div {
    text-align: center;
    margin-bottom: 5px;

    .van-button {
      padding: 10px 20px;
      width: 220px;
      font-size: 16px;
    }

    .van-button--default {
      background-color: #FFFFFF;
    }
  }
}

.qr-code-div {
  min-height: 100vh;
  background-position: bottom;
  background-repeat: space;
  background-size: cover;
  background-image: url('../../assets/images/coins/bg@2x.png');
  width: 100%;

  .qr-code-content {
    //background-color: #FFFFFF;
    //text-align: center;
    //width: 200px;
    //margin: auto;
    //box-shadow: 0px 0px 10px 1px #e6e5e5;
    //font-size: 18px;

    .qr-code {
      width: 180px;
      height: 160px;
      margin: auto;
      //padding: 10px;
    }

    .qr-code-text {
      padding: 0 10px;
    }

  }
}

.bg-up {
  padding: 0;
}

.bg-down {
  width: 100%;
  //position: fixed;

  img {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
  }
}

</style>
